const meanBy = (array = [], iteratee = '') =>
  array.reduce(
    (sum, row) =>
      (row.canExpand && row.isExpanded ? 0 : row.values[iteratee]) + sum,
    0
  )
export default meanBy
